// Needed these eslint rules to be disabled for this file
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable no-console */

import mammoth from "mammoth";
import workerUrl from "pdfjs-dist/build/pdf.worker.mjs?url";
import { pdfjs } from "react-pdf";

import { PopupActions } from "@store/popupStore";

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

const useFileProcessor = () => {
  const processPdfFile = async (file: File) => {
    try {
      const arrayBuffer = await file.arrayBuffer();

      const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;

      let extractedText = "";
      for (let index = 1; index <= pdf.numPages; index++) {
        const page = await pdf.getPage(index);
        const textContent = await page.getTextContent();

        extractedText += textContent.items
          .map((item) => {
            return "str" in item ? item.str : "";
          })
          .join(" ");
      }

      if (extractedText.length === 0) {
        PopupActions.openNotification({
          content: "No text found in PDF. Please try again.",
          title: "Error",
        });
      }

      return extractedText;
    } catch (error) {
      PopupActions.openNotification({
        content: "Error processing PDF. Please try again.",
        title: "Error",
      });
      console.error("Error processing PDF:", error);
    }
  };

  const processTextFile = async (file: File) => {
    try {
      const text = await file.text();
      if (text.length === 0) {
        PopupActions.openNotification({
          content: "No text found in file. Please try again.",
          title: "Error",
        });
      }
      return text;
    } catch (error) {
      PopupActions.openNotification({
        content: "Error processing text file. Please try again.",
        title: "Error",
      });
      console.error("Error processing text file:", error);
    }
  };

  const processDocxFile = async (file: File) => {
    try {
      const arrayBuffer = await file.arrayBuffer();

      const result = await mammoth.extractRawText({
        arrayBuffer: arrayBuffer,
      });

      if (result.value.length === 0) {
        PopupActions.openNotification({
          content: "No text found in DOCX. Please try again.",
          title: "Error",
        });
      }

      return result.value;
    } catch (error) {
      PopupActions.openNotification({
        content: "Error processing DOCX. Please try again.",
        title: "Error",
      });
      console.error("Error processing DOCX:", error);
    }
  };

  // Handle file upload
  const handleFileProcessing = async (file: File) => {
    switch (file.type) {
      case "application/pdf": {
        return await processPdfFile(file);
      }
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
        return await processDocxFile(file);
      }
      case "text/plain": {
        return await processTextFile(file);
      }
      default: {
        PopupActions.openNotification({
          content: "Unsupported file type. Please try again.",
          title: "Error",
        });
        console.warn("Unsupported file type");
      }
    }
  };

  return {
    handleFileProcessing,
  };
};

export default useFileProcessor;
